import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MessageConstant } from 'src/app/shared/constant/message.constant';
import { RequestHelper } from 'src/app/shared/helper/request.helper';
import { Router } from '@angular/router';
import { NavigationConstant } from 'src/app/shared/constant/navigation.constant';

@Component({
  selector: 'app-result',
  templateUrl: './result.component.html'
})
export class ResultComponent implements OnInit {

  @Input() state;
  @Input() redirectTo;

  image: any = 'fail';

  constructor(
    public activeModal: NgbActiveModal,
    private route: Router
  ) { }

  ngOnInit() {
    if (this.state === MessageConstant.PAYMENT_SUCCESS) {
      this.image = 'success';
    }
  }

  goBack() {
    this.activeModal.close();
    this.route.navigate([this.redirectTo]);
  }

  home() {
    this.activeModal.close();
    this.route.navigate([NavigationConstant.HOME]);
  }

}
